import { useDispatch } from 'react-redux';

import ListMenu from "../Commons/ListMenu";
import { setCurrentNavigation } from "../../slices/navigationSlice";
import useMount from '../../hooks/useMount';


import "./Admin.css";

const AdminPage = (props) =>
{
  //Redux
  const Dispatch = useDispatch();

  useMount(() =>
  {
    Dispatch(setCurrentNavigation("Admin"));
  }, []);

  return (
    <div>
      <div className="admin_text">
        Admin
      </div>
      <div className="admin_menu_cont">
        <ListMenu />
      </div>
    </div>
  )

};

export default AdminPage;